import React from 'react';
import { ArticleHeading3, ArticleHeading4, UIText2, UIText3, useDeviceType } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';
import { transformNumToString } from 'shared/utils/common';
import { PERCENT } from 'shared/constants/common';

import styles from './styles.css';
import { IOfferRate } from '../../../../repositories/mortgage-broker-calculator/entities/get_avaiable_multi_offers_v1/OfferRate';

export interface IRateBlockProps {
  rate: IOfferRate;
}

export const RateBlock: React.FC<IRateBlockProps> = ({ rate: { discount, rateWithDiscount, rate } }) => {
  const isDesktop = useDeviceType() === 'desktop';

  return (
    <>
      <div className={styles['title']}>
        <UIText2 color={'current_color'}>Ставка</UIText2>
      </div>
      <ConditionalWrapper if={isDesktop} ThenComponent={ArticleHeading4} ElseComponent={ArticleHeading3}>
        <div className={styles['rate-block']}>
          {discount && rateWithDiscount ? (
            <>
              {transformNumToString(rateWithDiscount)}
              {PERCENT}
              <div className={styles['discount-rate-block']}>
                <UIText3 color={'current_color'}>
                  -{transformNumToString(discount)}
                  {PERCENT}
                </UIText3>
              </div>
              <div className={styles['full-rate-block']}>
                <UIText2 color={'current_color'}>
                  {transformNumToString(rate)}
                  {PERCENT}
                </UIText2>
              </div>
            </>
          ) : (
            <>
              {transformNumToString(rate)}
              {PERCENT}
            </>
          )}
        </div>
      </ConditionalWrapper>
    </>
  );
};
